"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var init_exports = {};
__export(init_exports, {
  closeLiveQueries: () => closeLiveQueries,
  getLiveQueries: () => getLiveQueries,
  getOnDestroy: () => getOnDestroy,
  initLiveQueries: () => initLiveQueries,
  refreshLiveQueries: () => refreshLiveQueries
});
module.exports = __toCommonJS(init_exports);
var import_communication_query = require("@hcengineering/communication-query");
let lq;
let onDestroy = /* @__PURE__ */ __name(() => {
}, "onDestroy");
function getLiveQueries() {
  return lq;
}
__name(getLiveQueries, "getLiveQueries");
function getOnDestroy() {
  return onDestroy;
}
__name(getOnDestroy, "getOnDestroy");
function initLiveQueries(client, teronlake, destroyFn) {
  if (lq != null) {
    lq.close();
  }
  if (destroyFn != null) {
    onDestroy = destroyFn;
  }
  lq = new import_communication_query.LiveQueries(client, teronlake);
}
__name(initLiveQueries, "initLiveQueries");
async function refreshLiveQueries() {
  if (lq != null) {
    await lq.refresh();
  }
}
__name(refreshLiveQueries, "refreshLiveQueries");
function closeLiveQueries() {
  if (lq != null) {
    lq.close();
  }
}
__name(closeLiveQueries, "closeLiveQueries");
//# sourceMappingURL=init.js.map
